<script setup lang="ts">
defineProps<{
	disabled?: boolean;
}>();

defineEmits<{
	remove: [];
}>();
</script>

<template>
	<DTooltip :text="$t('filters.remove_filter')">
		<DButton
			class="text-muted"
			variant="ghost"
			color="neutral"
			icon="lucide:x"
			size="xs"
			:aria-label="$t('filters.remove_filter')"
			:disabled
			@click="() => $emit('remove')"
		/>
	</DTooltip>
</template>
